module.exports = __webpack_public_path__ + "img/1167.60a25b2b.gif";